<template>
  <div class="page-item">
    <base-section-title class="p-t-24 p-l-24 p-r-24 p-b-8" title="系统消息">
      <template v-slot:right-tool>
        <el-button
          v-if="total > 15"
          class="m-r-5 m-t-8"
          type="text"
          @click="goNoticeList"
        >
          查看更多
        </el-button>
      </template>
    </base-section-title>
    <el-scrollbar v-if="list.length">
      <div class="content">
        <div v-for="(item, index) in list" :key="index" class="list-item">
          <div class="text1 text-ellipsis" @click="openDetail(item)">
            {{ item.title }}
          </div>
          <div class="text2">{{ diffTime(item.createTime) }}</div>
        </div>
      </div>
    </el-scrollbar>
    <el-empty v-if="!list.length" class="content" :image="noData" />
    <el-dialog
      class="dialog"
      append-to-body
      title="消息通知详情"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="closeNotice"
    >
      <p class="detail-title">{{ currentNotice.title }}</p>
      <div class="detail-title-tip">
        <span>发送时间：{{ currentNotice.createTime }}</span>
      </div>
      <div class="detail-text">
        <p>
          {{ currentNotice.content }}
          <a v-if="jumpPageType" @click="jumpPage()">立即查看</a>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNotice">取 消</el-button>
        <el-button type="primary" @click="jumpPage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import { diffTime } from '@/utils/utils'
import { getMessagePageApi } from '@/api/notice'
import { workbenchServiceDict } from '@/dictionary/system'
import { isObject } from 'lodash'
import { noticeDict } from '@/dictionary/notice'
import { mapState } from 'vuex'

export default {
  name: 'HomeSystemInformation',

  components: {
    BaseSectionTitle
  },

  data() {
    return {
      noticeDict,
      workbenchServiceDict,

      noData: require('@/assets/images/home/SystemInformation-no-data.png'),
      dialogVisible: false, // 消息弹框
      currentNotice: {}, // 当前点击的消息
      jumpPageType: '', // 跳转平台
      list: [],
      total: 0,
      identityMap: {
        purchaser: 2,
        supplier: 1,
        agency: 3
      }
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    // 获取当中工作台身份
    isIdentity() {
      return workbenchServiceDict.translate(this.currentWorkbench)?.alias
    }
  },

  watch: {
    currentWorkbench: {
      handler: function(val) {
        if (val) {
          this.getLIst()
        }
      },
      immediate: true
    }
  },

  created() {},

  methods: {
    diffTime,
    getLIst() {
      const params = {
        page: 1,
        size: 7,
        isRead: 0,
        identity: this.identityMap[this.isIdentity]
      }
      getMessagePageApi(params)
        .then(res => {
          this.total = res.data.total
          this.list = res.data.records || []
        })
        .catch(err => {
          this.$message.error(err?.message || err)
        })
    },
    openDetail(row) {
      this.dialogVisible = true
      this.currentNotice = { ...row }
      if (!this.currentNotice.params) {
        this.jumpPageType = ''
        return
      }
      const _paramsJson = JSON.parse(this.currentNotice.params)
      this.currentNoticeParams = _paramsJson
      if (isObject(_paramsJson) && _paramsJson.pageType) {
        this.jumpPageType = _paramsJson.pageType
      } else {
        this.jumpPageType = ''
      }
    },
    closeNotice() {
      this.dialogVisible = false
    },
    jumpPage() {
      if (this.jumpPageType) {
        this.closeNotice(false)
        this.handleCommand()
      } else {
        this.closeNotice()
      }
    },
    goNoticeList() {
      this.$router.push({
        name: 'Notice'
      })
    },
    handleCommand() {
      const _params = JSON.parse(this.currentNotice.params) // 跳转数据
      // 跳转的平台数据
      const _platform = workbenchServiceDict.array.find(
        el => el.value === Number(this.currentNotice.identity)
      )
      const _pageInfo = noticeDict[_params.pageType]

      // 如果是外链则，直接跳转
      if (_pageInfo.type === 'outSide') {
        window.open(_pageInfo.linkFun(_params), _pageInfo.linkFun(_params))
        return
      }

      // 因为要区分采购人还是代理机构
      const _page = isObject(_pageInfo)
        ? _pageInfo[_platform.platform]
        : _pageInfo
      this.$router.push({
        name: _page,
        params: { ..._params }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 8px 8px 16px 8px;
  box-sizing: border-box;
  padding: 0;
  .content {
    //height: 785px;
  }
  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 52px;
    margin: 0 24px;
    &:after {
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      background: $info-fourth-color;
      height: 1px;
      width: 100%;
      content: '';
    }
    &:nth-last-child(1)::after {
      display: none;
    }
    .text1 {
      font-size: 14px;
      color: $text-color;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .text2 {
      width: 200px;
      text-align: right;
      font-size: 14px;
      color: $third-text-color;
    }
  }
}
p {
  margin-block-start: 0em;
  margin-block-end: 0em;
}
.detail-title {
  color: $text-color;
  font-size: pixel-to-rem($n: 22);
}
.detail-title-tip {
  color: $second-text-color;
  font-size: pixel-to-rem($n: 18);
  padding: pixel-to-rem($n: 30) 0;
  width: 100%;
  border-bottom: 1px solid $border-color;
}
.detail-text {
  color: $second-text-color;
  font-size: pixel-to-rem($n: 18);
  margin-top: pixel-to-rem($n: 30);
  a {
    color: $primary-color;
    margin-left: pixel-to-rem($n: 10);
    cursor: pointer;
    &:hover {
      color: $deep-primary-color;
    }
  }
}
::v-deep .el-table__row {
  cursor: pointer;
}
</style>
